module.exports = __webpack_public_path__ + "static/img/allRisks.3bbe792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/allRisks.jpg
// module id = wTvb
// module chunks = 4